// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"152":"notification-detail","602":"notification","966":"login"}[chunkId] + "." + {"152":"6340b170","602":"1a56bdbc","966":"3880d19c"}[chunkId] + ".js";
};